import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from './../../../environments/environment';
import { AuthGuard } from './../../security/guards/auth-guard/auth.guard';

@Injectable()
export class BuscaCep {
    private baseUrlService: string;
    private token: string;

    constructor(private http: HttpClient, public router: Router) {
        this.carregarToken();
        this.baseUrlService = environment.URL_API
    }

    private carregarToken() {
        try {
            this.token = new AuthGuard(this.router).getToken();
        } catch (Exception) {
            this.token = '';
        }
    }

    private getOptions(): Promise<any> {
        const headers = new HttpHeaders({ 'Authorization': this.token, 'Content-Type': 'application/json; charset=utf-8'});
        const httpOptions = { headers: headers }
        return this.http.post(`${this.baseUrlService}/cep/`, httpOptions).toPromise();
    }

    public get(numeroCep: string): Promise<any> {
        return this.http.get(`${this.baseUrlService}/cep/` + numeroCep).toPromise();
    }

}